import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';

@Component({
  selector: 'app-input-selectable-list-react',
  templateUrl: './input-selectable-list-react.component.html',
  styleUrls: ['./input-selectable-list-react.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSelectableListReactComponent),
      multi: true
    }
  ]
})

export class InputSelectableListReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  public spanMaxSize?: string = undefined;
  public spanMinSize?: string = undefined;

  public itensVinculados: Array<any> = [];
  public inputSelecionados: Array<any> = [];
  public outputSelecionados: Array<any> = [];

  @Input() inputSpan?: string = undefined;
  @Input() outputSpan?: string = undefined;

  @Input() maxSize?: number = undefined;
  @Input() minSize = 1;

  @Input() itens: Array<any> = [];
  @Input() nomePropriedade: string = undefined;
  @Input() idPropriedade: string = undefined;
  @Input() vincularObjeto = false;
  @Input() mostrarOrdenacao = true;
  @Input() mostrarEdit = false;

  @Output() editItemEmitter = new EventEmitter<any>()
  @Output() insertItemEmitter = new EventEmitter<any>();
  @Output() removeItemEmitter = new EventEmitter<any>();

  // @Input() campoAdicional?: 'text' | 'number' | null;
  // @Input() nomeCampoAdicional?;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.maxSize) {
      if (!this.spanMaxSize) {
        this.spanMaxSize = `Tamanho máximo de ${this.maxSize.toString()} itens`;
      }
    }
    if (this.minSize) {
      if (!this.spanMinSize) {
        this.spanMinSize = `Tamanho mínimo de ${this.minSize.toString()} itens`;
      }
    }
    this.loadValidators();
    this.setAndUpdateValidators();
    this.iniciarItens();
  }

  ngOnChanges(): void {
    super.ngOnChanges();
    this.loadValidators();
    this.setAndUpdateValidators();
    this.iniciarItens();
  }

  iniciarItens() {
    if (this.control && this.control.value) {
      if (this.idPropriedade && this.nomePropriedade) {
        if (this.vincularObjeto) {
          this.control.value.forEach(val => {
            if (this.itens.find(e => e != null && e[this.idPropriedade] === val[this.idPropriedade]) != null) {
              this.itensVinculados.push(this.itens.find(e => e != null && e[this.idPropriedade] === val[this.idPropriedade]))
            }
            this.itens.splice(this.itens.findIndex(e => e != null && e[this.idPropriedade] === val[this.idPropriedade]), 1)
          })
        } else {
          this.control.value.forEach(val => {
            if (this.itens.find(e => e != null && e[this.idPropriedade] === val) != null) {
              this.itensVinculados.push(this.itens.find(e => e != null && e[this.idPropriedade] === val))
            }
            this.itens.splice(this.itens.findIndex(e => e != null && e[this.idPropriedade] === val), 1)
          })
        }
      } else {
        this.control.value.forEach(val => {
          this.itensVinculados.push(this.itens.find(e => e === val))
          this.itens.splice(this.itens.findIndex(e => e === val), 1)
        })
      }
    }
    this.cdRef.detectChanges();
  }

  selecionarItensInput(event) {
    const listaOpcoes = event.target.children;
    this.inputSelecionados = [];
    for (const item of listaOpcoes) {
      if (item.selected) {
        if (this.idPropriedade && this.nomePropriedade) {
          this.inputSelecionados.push(this.itens.find(e => e != null && e[this.idPropriedade].toString() === item.value))
        } else {
          this.inputSelecionados.push(this.itens.find(e => e === item.value.toString()))
        }
      }
    }
  }

  selecionarItensOutput(event) {
    const listaOpcoes = event.target.children;
    this.outputSelecionados = [];
    for (const item of listaOpcoes) {
      if (item.selected) {
        if (this.idPropriedade && this.nomePropriedade) {
          this.outputSelecionados.push(this.itensVinculados.find(e => e != null && e[this.idPropriedade].toString() === item.value))
        } else {
          this.outputSelecionados.push(this.itensVinculados.find(e => e === item.value.toString()))
        }
      }
    }
  }

  moverItensAcima() {
    if (this.outputSelecionados && this.outputSelecionados.length > 0) {
      for (let i = 0; i < this.outputSelecionados.length; i++) {
        const elemento = this.outputSelecionados[i];
        const pos = this.itensVinculados.findIndex(e => e === elemento);
        const proxElemento = this.itensVinculados[pos - 1];

        this.itensVinculados[pos] = proxElemento;
        this.itensVinculados[pos - 1] = elemento;
        this.atualizarValorForm();
      }
    }
  }
  moverItensAbaixo() {
    if (this.outputSelecionados && this.outputSelecionados.length > 0) {
      for (let i = this.outputSelecionados.length - 1; i >= 0; i--) {
        const elemento = this.outputSelecionados[i];
        const pos = this.itensVinculados.findIndex(e => e === elemento);
        const proxElemento = this.itensVinculados[pos + 1];

        this.itensVinculados[pos] = proxElemento;
        this.itensVinculados[pos + 1] = elemento;
        this.atualizarValorForm();
      }
    }
  }

  habilitarMoverItensAcima() {
    if (this.outputSelecionados && this.outputSelecionados.length > 0) {
      const pos = this.itensVinculados.findIndex(e => e === this.outputSelecionados[0]);
      if (pos > 0) {
        return true;
      }
    }
    return false;
  }

  habilitarMoverItensAbaixo() {
    if (this.outputSelecionados && this.outputSelecionados.length > 0) {
      const element = this.itensVinculados.find(e => e === this.outputSelecionados[this.outputSelecionados.length - 1]);
      if (this.itensVinculados[this.itensVinculados.length - 1] !== element) {
        return true;
      }
    }
    return false;
  }

  vincularItens() {
    this.insertItemEmitter.emit(this.inputSelecionados);
    this.inputSelecionados.forEach(e => {
      const index = this.itens.findIndex(i => i === e);
      this.itensVinculados.push(this.itens[index]);
      this.itens.splice(index, 1);
    })
    this.atualizarValorForm()
    this.outputSelecionados = [];
    this.inputSelecionados = [];
  }

  desvincularItens() {
    this.removeItemEmitter.emit(this.outputSelecionados);
    this.outputSelecionados.forEach(e => {
      const index = this.itensVinculados.findIndex(i => i === e);
      this.itens.push(this.itensVinculados[index]);
      this.itensVinculados.splice(index, 1);
    })
    this.atualizarValorForm()
    this.outputSelecionados = [];
    this.inputSelecionados = [];
  }

  editarItens() {
    this.editItemEmitter.emit(this.outputSelecionados)
  }

  atualizarValorForm() {
    if (this.idPropriedade && this.nomePropriedade && !this.vincularObjeto) {
      const listaVal = [];
      this.itensVinculados.forEach(e => {
        if (e) {
          listaVal.push(e[this.idPropriedade])
        }
      })
      this.control.setValue(listaVal);
    } else {
      this.control.setValue(this.itensVinculados);
    }
  }


  private loadValidators(): void {
    if (this.maxSize) {
      this.insertValidator(this.customValidMaxSize(this.maxSize));
    }

    if (this.minSize) {
      this.insertValidator(this.customValidMinSize(this.minSize));
    }
  }

  public customValidMinSize(minSize) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value?.length >= minSize) {
        return null;
      }
      return { MinLengthArray: true };
    }
  }

  public customValidMaxSize(maxSize) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length < maxSize) {
        return null;
      }
      return { MaxLengthArray: true };
    }
  }

  public validMaxSize(): boolean {
    return this.control?.errors?.MaxLengthArray;
  }

  public validMinSize(): boolean {
    return this.control?.errors?.MinLengthArray;
  }

  public validSizeOutput(): boolean {
    return this.required && this.itensVinculados && this.itensVinculados.length > 0;
  }
  public validSizeInput(): boolean {
    return this.itens && this.itens.length > 0;
  }
}
